module.exports = __webpack_public_path__ + "static/troy-e7a04822f559c52166443d5832c0407e.png";